import React, { Component } from 'react';

var request=require('request');
var config=require('../config');
var guiUtils=require('../ApsHtmlGuiUtils');

class AccountHistory extends Component
{
	constructor(props){
		super(props);
		this.state={historyTable:[],activeAdh:''};
		this.getTable=this.getTable.bind(this);
		this.deleteLine=this.deleteLine.bind(this);
		
        this.renderDeleteButton=this.renderDeleteButton.bind(this);

	}
	
	deleteLine(lineId)
	{
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/deleteHistoryLine/'
			
			+
			"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'"+",'"+lineId+"'";
		console.log(str);	
			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
				window.location.reload(false);
				//	self.forceUpdate();
			}).catch(err=>{console.log('caught',err);
			});		  	
			
			
		
	}
	renderDeleteButton(lineId)
	{
		return (<div><input type='button' value='Supprimer' onClick={()=>this.deleteLine(lineId)} /></div>);
	}

	render()
	{
				return (<div id='PaymentsList'><div class='text'> {this.props.title}</div>
		<table> 
		<thead>
		<tr>
		<th>Nom</th>
		<th>Prénom</th>
		
		<th>Naissance</th>
		<th>FR</th>
		<th>EU</th>
		<th>Type</th>
		<th>Année</th>
		<th>Supprimer</th>
		
		</tr>
		</thead>
		<tbody>
		{this.state.historyTable.map(member =>
		
		<tr key={member.rlid}>
		
		<td>{member.nom} </td>
		<td>{member.prenom} </td>		
		<td>{member.naissance} </td>
		
		<td>{member.amountFR} </td>
		<td>{member.amountEU} </td>
		<td>{member.TypePaiement} </td>
		<td>{member._date} </td>
	
		<td>{this.renderDeleteButton(member.rlid)}</td>
		</tr>
		
		)}
		</tbody>
		</table>
		</div>);
	}
	
	componentDidMount()
	{
	    this.getTable();
	}
	
	
	getTable()
    {
		let self=this;
		let str=config.sqlServerAddress()+'/gRaw/getAccountHistory/'
			
			+
			"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
			
			fetch(str,{
			method:'GET'}).then(function(response){
				if(response.status>=400){
					throw new Error("Bad resp");
				}
				return response.json();
			}).then(function(data){
				self.setState({historyTable:data});
			//	self.forceUpdate();
			}).catch(err=>{console.log('caught',err);
			});		  	
    }		
}

export default AccountHistory;